import { clsx } from 'clsx'
import { Transition } from '@headlessui/react'
import { useTranslation } from 'react-i18next'
import { InputProps } from 'components/ui/Input'
import { useState } from 'react'
import { Icon } from 'components/ui/Icon'

export const InputPassword = ({ value, setValue, label, error, ...rest }: InputProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const { t } = useTranslation()
  return (
    <div className={'tw-flex tw-flex-col tw-text-sm tw-relative'}>
      <div className={'tw-text-white tw-mb-1'}>{label}</div>
      <input
        placeholder={label}
        className={clsx('tw-rounded-md tw-h-10 tw-bg-slate-300/40 tw-p-2 tw-border-[1px] focus:tw-outline-none', {
          'tw-border-red-500 tw-text-red-500': !!error,
          'tw-border-slate-300': !error,
        })}
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        {...rest}
      />
      <div
        className={'tw-text-xs tw-text-white tw-w-4 tw-cursor-pointer tw-mt-1 tw-absolute tw-right-3 tw-bottom-3'}
        onClick={() => setShowPassword(!showPassword)}
      >
        <Icon icon={['far', showPassword ? 'eye-slash' : 'eye']} />
      </div>
      <Transition
        show={!!error}
        enter="tw-transition-opacity tw-duration-300"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-300"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
        className={'tw-text-red-500 tw-text-xs'}
      >
        {t(error)}
      </Transition>
    </div>
  )
}
